import Axios from "axios";

export const uploadDocument = (customerId, personId, documentType, documentSubtype, document) => {
    const formData = new FormData();
    formData.append("file", document);
    formData.append("documentType", documentType);
    formData.append("documentSubtype", documentSubtype);
    return Axios.post(`/api/customer/${customerId}/person/${personId}/document`, formData);
};

export const uploadDocumentForOcrQuickEntry = (customerId, personId, documentType, documentSubtype, document) => {
    const formData = new FormData();
    formData.append("file", document);
    formData.append("documentType", documentType);
    formData.append("documentSubtype", documentSubtype);
    return Axios.post(`/api/customer/${customerId}/person/${personId}/ocr_quick_entry/document/`, formData);
};

export const uploadDocumentBase64DataForOcrQuickEntry = (
    customerId,
    personId,
    documentType,
    documentSubtype,
    fileName,
    documentBase64
) => {
    return Axios.post(`/api/customer/${customerId}/person/${personId}/ocr_quick_entry_base64/document/`, {
        documentType: documentType,
        documentSubtype: documentSubtype,
        fileName: fileName,
        base64File: documentBase64,
    });
};

export function deleteDocument(customerId, personId, documentId) {
    return Axios.post(`/api/customer/${customerId}/person/${personId}/document`, formData);
}
